import {
  ADMIN_API,
} from "@/config";

export const apiConstants = {
  auth: `${ADMIN_API}/auth`,
  userLogged : `${ADMIN_API}/auth/user`,
}
